import React, { useState, useEffect } from "react";
import { BookOpen, Loader2 } from "lucide-react";
import { academicService } from "../../services/academicService";

export const CourseConfigurationPage: React.FC = () => {
  const [courses, setCourses] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const data = await academicService.getSubjects();
      setCourses(data.results || data || []);
    } catch {
      setCourses([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-5 bg-slate-900/90 border border-slate-800 rounded-xl shadow-md text-xs font-sans space-y-4">
      <div className="flex items-center justify-between pb-3 border-b border-slate-800">
        <div className="flex items-center gap-2">
          <BookOpen className="w-5 h-5 text-indigo-400" />
          <h2 className="text-base font-bold text-slate-100">Course Syllabus & Credit Configuration</h2>
        </div>
      </div>

      {loading ? (
        <div className="p-8 text-center text-slate-400 text-xs flex items-center justify-center gap-2">
          <Loader2 className="w-4 h-4 animate-spin text-indigo-400" /> Loading Course Catalog...
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-slate-800 bg-slate-950">
          <table className="w-full text-left text-xs text-slate-300">
            <thead className="bg-slate-900 text-[10px] font-mono uppercase text-slate-400 border-b border-slate-800">
              <tr>
                <th className="p-3">Subject / Course Code</th>
                <th className="p-3">Title</th>
                <th className="p-3">Type</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-800 font-mono">
              {courses.length === 0 ? (
                <tr>
                  <td colSpan={3} className="p-8 text-center font-sans">
                    <BookOpen className="w-10 h-10 text-slate-600 mx-auto mb-2" />
                    <h3 className="text-sm font-bold text-slate-200 mb-1">No Courses Available</h3>
                    <p className="text-xs text-slate-400">No course syllabus or subject configurations exist in the catalog for this tenant.</p>
                  </td>
                </tr>
              ) : (
                courses.map((c) => (
                  <tr key={c.id} className="hover:bg-slate-850">
                    <td className="p-3 font-bold text-indigo-400">{c.code || `SUB-${c.id}`}</td>
                    <td className="p-3 font-sans font-bold text-slate-100">{c.name}</td>
                    <td className="p-3">
                      <span className="px-2 py-0.5 rounded text-[10px] bg-indigo-950 text-indigo-300 border border-indigo-800 font-bold uppercase">
                        {c.subject_type || "THEORY"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
